import { useMemo } from 'react';

export function usePasswordValidation(password) {
    return useMemo(() => {
        const checks = {
            length: password.length >= 8,
            uppercase: /[A-Z]/.test(password),
            lowercase: /[a-z]/.test(password),
            digit: /\d/.test(password),
            special: /[^A-Za-z0-9]/.test(password),
        };
        return { checks, valid: Object.values(checks).every(Boolean) };
    }, [password]);
}

export default function PasswordRequirements({ password }) {
    const { checks } = usePasswordValidation(password);

    if (password.length === 0) return null;

    return (
        <div className="password-requirements">
            <p>Password requirements:</p>
            <ul>
                <li className={checks.length ? 'met' : ''}>
                    {checks.length ? '\u2713' : '\u2022'} At least 8 characters
                </li>
                <li className={checks.uppercase ? 'met' : ''}>
                    {checks.uppercase ? '\u2713' : '\u2022'} One uppercase letter
                </li>
                <li className={checks.lowercase ? 'met' : ''}>
                    {checks.lowercase ? '\u2713' : '\u2022'} One lowercase letter
                </li>
                <li className={checks.digit ? 'met' : ''}>
                    {checks.digit ? '\u2713' : '\u2022'} One digit
                </li>
                <li className={checks.special ? 'met' : ''}>
                    {checks.special ? '\u2713' : '\u2022'} One special character
                </li>
            </ul>
        </div>
    );
}
